export default function blogItemProps() {
  return {
    __typename: {
      required: true,
      type: String,
    },
    author: {
      required: true,
      type: Object,
    },
    date: {
      required: true,
      type: String,
    },
    dateUpdated: {
      required: true,
      type: String,
    },
    headerImage: {
      required: true,
      type: Array,
    },
    id: {
      required: true,
      type: String,
    },
    postType: {
      default: null,
      type: Array,
    },
    readingTime: {
      required: true,
      type: String,
    },
    slug: {
      required: true,
      type: String,
    },
    summary: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    uri: {
      required: true,
      type: String,
    },
    customStructuredData: {
      required: false,
      type: String,
    },
    howToStructuredDataName: {
      required: false,
      type: String,
    },
    howToStructuredData: {
      required: false,
      type: Array,
    },
    faqStructuredData: {
      required: false,
      type: Array,
    },
    structuredDataType: {
      required: false,
      type: Array,
    },
  };
}
